// ----------------------------------------------------------------------
// <copyright file="Izenda.UIContants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  fontFamily: {
    roboto: 'Roboto',
    georgia: 'Georgia',
    palatinoLinotype: 'Palatino Linotype',
    bookAntiqua: 'Book Antiqua',
    timesNewRoman: 'Times New Roman',
    arial: 'Arial',
    helvetica: 'Helvetica',
    arialBlack: 'Arial Black',
    impact: 'Impact',
    lucidaSansUnicode: 'Lucida Sans Unicode',
    tahoma: 'Tahoma',
    verdana: 'Verdana',
    courierNew: 'Courier New',
    lucidaConsole: 'Lucida Console'
  },
  fontSize: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
  defaultFontSize: 14,
  defaultFontFamily: 'Roboto',
  defaultUnitType: 'px',
  copyright: 'Copyright 2016 Izenda, Inc.',
  columnWidthSetting: {
    get pixels() {
      return localizer.getText('UI_CONSTANT_PIXELS');
    },
    get characters() {
      return localizer.getText('UI_CONSTANT_CHARACTERS');
    }
  },
  borderColor: '#000',
  dashStyles: ['solid', 'dotted', 'dashed'],
  borderWidth: 1,
  borderWidthMin: 1,
  borderWidthMax: 6,
  reportPartGridDefault: {
    backgroundColor: '#fff'
  },
  backgroundColor: '#fff',
  textColor: '#000',
  textBackgrounColor: '#fff',
  defaultDashStyles: 'solid',
  MATH: {
    maxSignedInt32Bits: Math.pow(2, 31) - 1
  },
  SIZE: {
    WIDTH: {
      VALUE: null,
      UNIT: 'Pixels'
    }
  },

  Number: {
    DECIMAL_FORMAT: '-#,###.##',
    MIN: Number.MIN_SAFE_INTEGER,
    MAX: Number.MAX_SAFE_INTEGER
  },

  CHECKBOX_STATUS: {
    CHECKED: 'checked',
    UNCHECK: 'unchecked',
    INDETERMINATE: 'indeterminate'
  },

  Messages: {
    get NoDataToShow() {
      return localizer.getText('NO_DATA_TO_SHOW');
    }
  },
  UNDEFINED_VALUE: '[UNDEFINED VALUE]',
  NULL_VALUE: '[NULL]',
  BLANK_VALUE: '[BLANK]',
  dropdownMaxHeight: 240,
  DEFAUFT_DROPDOWN_ITEMS: 8,
  LAZY_LOADING_DEFAULT_ITEMS_NUMBER: 100,
  LAZY_LOADING_DEFAULT_PAGE_INDEX: 3,
  DEFAULT_DEBOUNCE_TIME: 500,
  MIDDLE_PANEL_LIST_MAX_HEIGHT: 780,
  BASE_PADDING_TOP_WITH_PARENT_PIXEL: 30,
  PAGING_SIZE_OPTIONS: [10, 25, 50, 100, 200],
  MASKED_TEXT: '●●●●●●●●●●'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.UIConstants.js